import type { paths } from '@luxuryescapes/contract-trip'
import request from 'api/requestUtils'
import { baseUri, getOptions } from './utils'

// Long enough to upload and transcribe a minutes-long recording; a stalled request must release the composer.
const TRANSCRIPTION_TIMEOUT_MS = 60_000

export type TranscribeAudioParams = {
  audio: Blob
  filename?: string
  accessToken?: string
  signal?: AbortSignal
}

type TranscribeAudioApiResponse =
  paths['/api/trips/v2/transcribe']['post']['responses']['200']['content']['application/json']

export type TranscribeAudioResponse = TranscribeAudioApiResponse['result']

export async function transcribeAudio({
  audio,
  filename = 'recording.webm',
  accessToken,
  signal,
}: TranscribeAudioParams): Promise<TranscribeAudioResponse> {
  const formData = new FormData()
  formData.append('file', audio, filename)

  const response = await request.post<TranscribeAudioApiResponse, FormData>(
    `${baseUri}/v2/transcribe`,
    formData,
    { ...getOptions(accessToken), timeout: TRANSCRIPTION_TIMEOUT_MS, signal },
  )

  return response.result
}
